import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PostFilterService {

  private messageSource = new BehaviorSubject("All");
  currentMessage = this.messageSource.asObservable();

  private messageSource1 = new BehaviorSubject("");
  currentMessage1 = this.messageSource1.asObservable();

  private messageSource2 = new BehaviorSubject("");
  currentMessage2 = this.messageSource2.asObservable();

  private messageSource3 = new BehaviorSubject("");
  currentMessage3 = this.messageSource3.asObservable();

  private messageSource4 = new BehaviorSubject("");
  currentMessage4 = this.messageSource4.asObservable();

  private messageSource5 = new BehaviorSubject("");
  currentMessage5 = this.messageSource5.asObservable();


  constructor() { }

  changeMessage(message: string) {
    this.messageSource.next(message)
  }

  detectLink(data: string) {
    // console.log(data, 'dataa')
    this.messageSource2.next(data)
  }

  getLink(link: string){
    this.messageSource1.next(link);
  }

  imageRefresher(link: string){
    this.messageSource3.next(link);
  }

  chatImageRefresher(link: string){
    this.messageSource4.next(link);
  }

  getUserId(link: string){
    this.messageSource5.next(link);
  }


}
